module.exports = __webpack_public_path__ + "img/plan_step4.c1bd201f.png";